import axios, { AxiosRequestConfig } from 'axios'

import { COMPANY_API_URL } from '../constants/urls'

export const companyApiClient = axios.create({
  baseURL: COMPANY_API_URL,
  timeout: 30000
})

companyApiClient.interceptors.request.use((config: AxiosRequestConfig) => {
  const token = localStorage.getItem('token')

  const newConfig = config
  if (token) {
    newConfig.headers = {
      ...(newConfig.headers ?? {}),
      'x-api-key': token
    }
  }
  return newConfig
})

export default companyApiClient
